export default __webpack_public_path__ + "static/media/gif_ui.401384b0.gif";